import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useContentLanguages } from "@common/composable/useMetaDataStore";
import { AttributeGroup } from "@medapro-types/common/common";
import { Branch, Leaf, MultiLevelNavigationConfirmModel, MultiLevelNavigationSelectionModel } from "@medapro-types/common/components/MultiLevelNavigation";
import articleApi from "@services/article.js";
import { BaseIds } from "@util/enums/base-ids";
import { computed, reactive } from "vue";
import { useI18n } from "vue-i18n";
import MultiLevelNavigationModal from "./MultiLevelNavigationModal.vue";

const BRANCH_ICON = "AttributeGroup1";

//#region General
type ViewModel = { rootSelection: MultiLevelNavigationSelectionModel | null };

export default /*#__PURE__*/_defineComponent({
  __name: 'AttributeGroupSelectionModal',
  props: {
    value: { type: Boolean },
    selectedEntryId: {},
    selectedPath: {}
  },
  emits: ["confirm", "cancel", "close", "input", "hide"],
  setup(__props: any, { emit: emits }) {

const props = __props;





const { t: $t } = useI18n();
const vm = reactive<ViewModel>({ rootSelection: null });
//#endregion

//#region Store

const { primaryLanguageCode } = useContentLanguages();

//#endregion

const onConfirm = (event: MultiLevelNavigationConfirmModel) => {
  if (confirm($t("confirm.change.attributeGroup"))) emits("confirm", event);
};

//#region CONSTANTS
const BASE_ATTRIBUTE_GROUP_ID = BaseIds.BaseAttributeGroup;
//#endregion

//#region localValue
const localValue = computed({
  get: () => props.value,
  set: (nv) => emits("input", nv)
});

//#endregion

//#region FetchMethods
const getAttributeGroups = async (groupId: string | null | undefined): Promise<Branch[]> => {
  if (!groupId) {
    vm.rootSelection = {
      icon: "Home",
      id: BASE_ATTRIBUTE_GROUP_ID,
      name: `<${$t("baseAttributeGroup")}>`,
      type: "all"
    };
  } else {
    vm.rootSelection = null;
  }
  const fetchResult: AttributeGroup[] = await articleApi.getAttributeGroups({
    language: primaryLanguageCode.value,
    id: groupId ?? BASE_ATTRIBUTE_GROUP_ID
  });
  return fetchResult.map((x) => ({ id: x.attributeGroupId, depth: x.depth, name: x.name, parentId: x.parentId, icon: BRANCH_ICON }));
};

const getAttributes = async (): Promise<Leaf[]> => {
  return [];
};
//#endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MultiLevelNavigationModal, {
    modelValue: localValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localValue).value = $event)),
    "modal-title": _unref($t)('selectAttributeGroup'),
    "fetch-branches": getAttributeGroups,
    "fetch-leaves": getAttributes,
    "selectable-type": ['branch'],
    "selected-entry-id": _ctx.selectedEntryId,
    "selected-path": _ctx.selectedPath,
    "base-path-title": _unref($t)('baseAttributeGroup'),
    "root-selection": vm.rootSelection,
    onConfirm: onConfirm,
    onHide: _cache[1] || (_cache[1] = ($event: any) => (emits('hide'))),
    onCancel: _cache[2] || (_cache[2] = ($event: any) => (emits('cancel'))),
    onClose: _cache[3] || (_cache[3] = ($event: any) => (emits('close')))
  }, null, 8, ["modelValue", "modal-title", "selected-entry-id", "selected-path", "base-path-title", "root-selection"]))
}
}

})